var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from "../BaseModel";
import LoyaltyPointsModel from "./LoyaltyPointsModel";
var LoyaltyInfoModel = /** @class */ (function (_super) {
    __extends(LoyaltyInfoModel, _super);
    function LoyaltyInfoModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.canGiveFeedBack = hydrated.canGiveFeedBack;
        _this.lastVisitDate = hydrated.lastVisitDate;
        _this.points = hydrated.points;
        _this.vipLevel = hydrated.vipLevel;
        _this.receiveOffers = hydrated.receiveOffers;
        return _this;
    }
    LoyaltyInfoModel.prototype.hydrate = function (data) {
        var loyaltyInfo = {};
        loyaltyInfo.canGiveFeedBack = data.can_give_feedback || null;
        loyaltyInfo.lastVisitDate = data.last_visit_date || null;
        loyaltyInfo.points = data.points ? new LoyaltyPointsModel(data.points) : null;
        loyaltyInfo.vipLevel = typeof data.vip_level !== undefined ? data.vip_level : null;
        loyaltyInfo.receiveOffers = (data.hasOwnProperty("receive_offers")) ? data.receive_offers : false;
        return loyaltyInfo;
    };
    LoyaltyInfoModel.prototype.updateReceiveOffers = function (receiveOffers) {
        this.receiveOffers = receiveOffers;
    };
    return LoyaltyInfoModel;
}(BaseModel));
export default LoyaltyInfoModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/loyalty/LoyaltyInfoModel.ts
// module id = null
// module chunks = 